import { EyeIcon, SparklesIcon, ShieldAlertIcon, ClipboardListIcon } from 'lucide-react';

export const images = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/uaRr9x8CASn5Z8rgB3tWcQ/WhatsApp_Image_2026-09-04_at_21.51.30_(5).webp',
    alt: 'Página del planificador: Las 5 Semanas en Detalle, con enfoque, energía y ejercicios clave por semana'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qsQTMJuoraH6h6dnVvzZaH/WhatsApp_Image_2026-09-04_at_21.51.30_(4).webp',
    alt: 'Página de estrategias de indicación para grupos mixtos, con frases listas por nivel'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qj9yLoaNQr779yAqxoBTS1/WhatsApp_Image_2026-09-04_at_21.51.30_(3).webp',
    alt: 'Ficha técnica del Ejercicio 29, Pelvic Lift, con cues de ejecución en Reformer'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/48N46n7odXPywY4yfQHKWs/WhatsApp_Image_2026-09-04_at_21.51.30_(2).webp',
    alt: 'Ficha técnica del Ejercicio 02, Trabajo de Pies - Arcos, con indicaciones de alineación'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tHeQ8VBn3s9cLQrnWwtEwN/WhatsApp_Image_2026-09-04_at_21.51.30_(1).webp',
    alt: 'Ficha técnica del ejercicio Forward Lunge en Silla de Pilates'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qdHDEWD45JXjJ9S58RBzTt/WhatsApp_Image_2026-09-04_at_21.51.30.webp',
    alt: 'Ficha técnica de Prensa de piernas con banda, con error frecuente y corrección destacados'
  }
];

export const highlights = [
  {
    icon: EyeIcon,
    title: 'Claridad Instantánea',
    text: 'Fotografía técnica real para que no haya dudas sobre la ejecución.'
  },
  {
    icon: SparklesIcon,
    title: 'Cues de Élite',
    text: 'Las frases exactas que disparan la conexión mente-cuerpo de tus alumnas.'
  },
  {
    icon: ShieldAlertIcon,
    title: 'Seguridad Garantizada',
    text: 'Errores frecuentes resaltados visualmente para que actúes antes de que ocurra la lesión.'
  },
  {
    icon: ClipboardListIcon,
    title: 'Estrategia Aplicada',
    text: 'Guías de indicación para grupos mixtos y planificadores semanales que hacen el 90% del trabajo por ti.'
  }
];
